/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./luckyCode.vue?vue&type=template&id=0b8a2edc&scoped=true"
import script from "./luckyCode.vue?vue&type=script&lang=js"
export * from "./luckyCode.vue?vue&type=script&lang=js"
import style0 from "./luckyCode.vue?vue&type=style&index=0&id=0b8a2edc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8a2edc",
  null
  
)

export default component.exports